export default __webpack_public_path__ + "static/media/pin.994dcc48.svg";